/**
 * Sticky bar: show when selection exists; primary Confirm proceeds.
 */
export default function SelectionConfirmBar({
  count = 0,
  label = 'selected',
  confirmLabel = 'Confirm',
  onConfirm,
  onClear,
  disabled = false,
  className = '',
}) {
  if (!count) return null;
  return (
    <div
      className={`sticky bottom-0 z-20 flex flex-wrap items-center justify-between gap-3 border-t border-gray-200 bg-white/95 px-4 py-3 shadow-[0_-4px_12px_rgba(0,0,0,0.06)] ${className}`}
      style={{ paddingBottom: 'max(0.75rem, env(safe-area-inset-bottom, 0px))' }}
    >
      <p className="text-sm text-gray-700">
        <span className="font-semibold text-gray-900">{count}</span> {label}
      </p>
      <div className="flex items-center gap-2">
        {onClear && (
          <button
            type="button"
            onClick={onClear}
            className="px-3 py-2 text-sm border border-gray-300 rounded-lg hover:bg-gray-50"
          >
            Clear
          </button>
        )}
        <button
          type="button"
          onClick={onConfirm}
          disabled={disabled || count < 1}
          className="px-4 py-2 text-sm font-medium bg-primary-600 text-white rounded-lg hover:bg-primary-700 disabled:opacity-50"
        >
          {confirmLabel}
        </button>
      </div>
    </div>
  );
}
